import { createSelector } from 'reselect'
import get from 'lodash-es/get'

export const getUserCollections = state => state.user.collections

export const getUserCartItems = state => get(state, 'user.cart.entries') || []

export const getUserProfile = state => get(state, 'user.profile', {})

export const getUserCart = state => get(state, 'user.cart')

export const getUserFavoriteCollectionID = createSelector(
  [getUserCollections],
  collections => {
    return Object.keys(collections).filter(
      collectionID => collections[collectionID].special_role === 'favorite'
    )[0]
  }
)

export const getMarketHeaderUser = createSelector(
  [getUserProfile, getUserCart],
  (profile, cart) => ({
    profile,
    cart
  })
)
